import { render, staticRenderFns } from "./my_reply.vue?vue&type=template&id=48be5b64&scoped=true"
import script from "./my_reply.vue?vue&type=script&lang=js"
export * from "./my_reply.vue?vue&type=script&lang=js"
import style0 from "./my_reply.vue?vue&type=style&index=0&id=48be5b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be5b64",
  null
  
)

export default component.exports